import { Event, track } from 'app/lib/analytics';
import { useUser } from 'app/network/user';
import type { User } from 'app/types/user';

export function trackClickedStreakFlame(user: User | undefined) {
  if (user?.hasShared === undefined) return;

  track(Event.ClickedStreakFlame, {
    streak_mode: user.hasShared ? 'monthly_streak' : 'pre_streak',
  });
}

export function useTrackStreakFlameClick() {
  const { data: user } = useUser();

  return () => {
    trackClickedStreakFlame(user);
  };
}
